/* ==========================================================================
   Megamenú nativo del tema (reemplaza la app de megamenú)
   - Cambio de imagen al pasar el cursor en el layout "split"
   - Apertura por toque en dispositivos táctiles (el primer toque abre, el
     segundo navega)
   - Cierre con Escape y al hacer clic fuera
   - aria-expanded sincronizado con el estado real del panel
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_CLASS = 'vz-is-open';
  // Margen para llegar al panel sin que se cierre por el camino.
  var CLOSE_DELAY = 260;

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  /* ---------------------------------------------------------------------
     Layout "split": la imagen de la derecha sigue al elemento resaltado
     --------------------------------------------------------------------- */
  function initSplit(panel) {
    var rows = panel.querySelectorAll('[data-vz-row]');
    var media = panel.querySelectorAll('[data-vz-media]');
    if (!rows.length || !media.length) return;

    function activate(index) {
      // Si el elemento no tiene imagen propia se usa la de reserva; si tampoco
      // la hay, se deja la que estuviera visible en vez de vaciar el panel.
      var target =
        panel.querySelector('[data-vz-media="' + index + '"]') ||
        panel.querySelector('[data-vz-media="default"]');

      if (target) {
        media.forEach(function (item) {
          item.classList.toggle('is-active', item === target);
        });
      }

      rows.forEach(function (row) {
        row.classList.toggle('is-active', row.getAttribute('data-vz-row') === String(index));
      });
    }

    rows.forEach(function (row) {
      var index = row.getAttribute('data-vz-row');
      row.addEventListener('mouseenter', function () {
        activate(index);
      });
      row.addEventListener('focusin', function () {
        activate(index);
      });
    });

    // Estado inicial: el primer panel que exista, si el Liquid no marcó ninguno.
    var initial = panel.querySelector('.vz-mega__pane.is-active');
    if (!initial && media.length) media[0].classList.add('is-active');
  }

  /* ---------------------------------------------------------------------
     Apertura / cierre
     --------------------------------------------------------------------- */
  function closeAll(except) {
    document.querySelectorAll('li.vz-has-mega.' + OPEN_CLASS).forEach(function (item) {
      if (item === except) return;
      item.classList.remove(OPEN_CLASS);
      var trigger = item.querySelector('[data-vz-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initItem(item) {
    var trigger = item.querySelector('[data-vz-trigger]');
    var panel = item.querySelector('[data-vz-panel]');
    if (!trigger || !panel) return;

    initSplit(panel);

    // Puntero fino (ratón): el CSS abre al instante con :hover. El JS añade
    // una demora al cerrar para que dé tiempo a cruzar hasta el panel aunque
    // el cursor pase un momento por fuera del <li>.
    var closeTimer = null;

    item.addEventListener('mouseenter', function () {
      if (isTouch()) return;
      clearTimeout(closeTimer);
      // Cierra ya cualquier otro panel abierto. Sin esto el anterior seguia
      // con su demora de cierre y los dos se veian superpuestos al pasar de
      // un elemento del menu al siguiente.
      closeAll(item);
      item.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', function () {
      if (isTouch()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    });

    // Táctil: el primer toque abre, el segundo sigue el enlace.
    trigger.addEventListener('click', function (event) {
      if (!isTouch()) return;
      if (!item.classList.contains(OPEN_CLASS)) {
        event.preventDefault();
        closeAll(item);
        item.classList.add(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    // Teclado: Enter/Espacio alterna sin navegar cuando el panel está cerrado.
    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      item.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.blur();
    });

    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      item.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });
  }

  /* ---------------------------------------------------------------------
     Móvil: desplegables del cajón

     No se usa <details>/<summary> ni <button> porque MenuDrawer (global.js)
     engancha todos los que encuentra dentro del cajón y les aplica su
     animación de panel deslizante, que es lo que cortaba los submenús.
     Un span con role="button" no lo toca nadie más.
     --------------------------------------------------------------------- */
  function initMobileToggles(root) {
    (root || document).querySelectorAll('[data-vz-toggle]').forEach(function (toggle) {
      if (toggle.dataset.vzReady === 'true') return;
      toggle.dataset.vzReady = 'true';

      var group = toggle.parentElement;
      var panel = toggle.nextElementSibling;
      if (!group || !panel) return;

      function toggleOpen(event) {
        event.preventDefault();
        event.stopPropagation();
        var isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }

      toggle.addEventListener('click', toggleOpen);
      toggle.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          toggleOpen(event);
        }
      });
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('li.vz-has-mega').forEach(function (item) {
      if (item.dataset.vzReady === 'true') return;
      item.dataset.vzReady = 'true';
      initItem(item);
    });
    initMobileToggles(scope);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('li.vz-has-mega')) closeAll();
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // El personalizador vuelve a renderizar la sección del encabezado.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
